import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { PageHeader } from '../components/PageHeader';
import { Footer } from '../components/Footer';
import { FuelIcon, DropletIcon, ClockIcon, ShoppingBagIcon, CarIcon, SparklesIcon } from 'lucide-react';
const fuels = [{
  name: 'Super (E5)',
  color: 'bg-green-500'
}, {
  name: 'Super E10',
  color: 'bg-green-400'
}, {
  name: 'Diesel',
  color: 'bg-yellow-500'
}, {
  name: 'LPG / Autogas',
  color: 'bg-blue-400'
}, {
  name: 'AdBlue',
  color: 'bg-sky-400'
}];
const services = [{
  icon: ShoppingBagIcon,
  title: 'Shell Shop',
  desc: 'Snacks, Getränke, Reisebedarf und mehr – alles für unterwegs.'
}, {
  icon: CarIcon,
  title: 'Waschanlage',
  desc: 'Moderne Waschanlage für PKW – schnell und gründlich.'
}, {
  icon: SparklesIcon,
  title: 'Saubere Anlage',
  desc: 'Gepflegte Sanitäranlagen und ein sauberes Tankstellengelände.'
}, {
  icon: DropletIcon,
  title: 'AdBlue-Säule',
  desc: 'Separate AdBlue-Zapfsäule für PKW und LKW verfügbar.'
}];
const stagger = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.1
    }
  }
};
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 30
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function TankstellePage() {
  return <>
      <PageHeader title="Shell Tankstelle" subtitle="20 Zapfsäulen. Alle Kraftstoffe. Immer verfügbar." image="https://images.unsplash.com/photo-1545262810-77515befe149?w=1200&q=80" accentColor="text-transparent bg-clip-text bg-gradient-to-r from-white to-red-500" accentGlow="bg-red-500" data-id="element-479" />

      <section className="py-20 px-4 bg-base" data-id="element-480">
        <div className="max-w-7xl mx-auto" data-id="element-481">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="max-w-3xl mb-20" data-id="element-482">
            <h2 className="text-4xl font-heading font-bold mb-6 text-gray-900" data-id="element-483">
              Tanken ohne Wartezeit
            </h2>
            <p className="text-lg text-gray-500 leading-relaxed" data-id="element-484">
              Unsere Shell Tankstelle mit 20 Zapfsäulen sorgt für schnelle
              Abfertigung – auch zu Stoßzeiten. Alle gängigen Kraftstoffe sind
              rund um die Uhr verfügbar. Ob PKW, Transporter oder Wohnmobil –
              bei uns sind Sie bestens versorgt.
            </p>
          </motion.div>

          <h3 className="text-3xl font-heading font-bold mb-8 text-gray-900" data-id="element-485">
            Verfügbare Kraftstoffe
          </h3>
          <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={{
          once: true
        }} className="flex flex-wrap gap-4 mb-20" data-id="element-486">
            {fuels.map(fuel => <motion.div key={fuel.name} variants={fadeUp} className="glass-card px-6 py-4 rounded-xl flex items-center gap-3" data-id="element-487">
                <div className={`w-3 h-3 rounded-full ${fuel.color}`} data-id="element-488" />
                <span className="text-gray-700 font-medium" data-id="element-489">{fuel.name}</span>
              </motion.div>)}
          </motion.div>

          <h3 className="text-3xl font-heading font-bold mb-8 text-gray-900" data-id="element-490">
            Services & Angebote
          </h3>
          <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={{
          once: true
        }} className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-20" data-id="element-491">
            {services.map(s => {
            const Icon = s.icon;
            return <motion.div key={s.title} variants={fadeUp} className="glass-card p-8 rounded-2xl border-red-500/10" data-id="element-492">
                  <div className="w-12 h-12 rounded-xl bg-red-500/10 flex items-center justify-center mb-5" data-id="element-493">
                    <Icon className="w-6 h-6 text-red-500" strokeWidth={1.5} data-id="element-494" />
                  </div>
                  <h3 className="text-xl font-heading font-bold mb-2 text-gray-900" data-id="element-495">
                    {s.title}
                  </h3>
                  <p className="text-gray-500" data-id="element-496">{s.desc}</p>
                </motion.div>;
          })}
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="glass-card p-8 rounded-2xl border-red-500/20 max-w-xl" data-id="element-497">
            <div className="flex items-center gap-3 mb-4" data-id="element-498">
              <ClockIcon className="w-5 h-5 text-red-500" data-id="element-499" />
              <h3 className="text-xl font-heading font-bold text-gray-900" data-id="element-500">
                Öffnungszeiten
              </h3>
            </div>
            <p className="text-gray-700" data-id="element-501">
              24 Stunden geöffnet – 7 Tage die Woche
            </p>
            <div className="flex items-center gap-3 mt-4" data-id="element-502">
              <FuelIcon className="w-5 h-5 text-red-500" data-id="element-503" />
              <p className="text-gray-500 text-sm" data-id="element-504">
                20 Zapfsäulen für schnelle Abfertigung
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      <Footer data-id="element-505" />
    </>;
}